import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import SanitizeHTML from "../../../sanitize-html/sanitize.html";
import {ReportChartComponent} from "../types/report.chart.component";

const ReportDetails: React.FC<ReportChartComponent> = useAppStore()((props: ReportChartComponent) => {
	const store = props.appStore.reportPageStore;

	const separateTextByLineBrake = (taxonomyText: string) => {
		return taxonomyText.split("\n").filter((tt) => tt !== "");
	};

	return (
		<>
			<h2 className="cih-h2 cih-hide-print">Your report</h2>
			{store.questionnaireAnswerSheetDetails.taxonomyTexts.map((tt) => {
				const separatedText = separateTextByLineBrake(tt.text);
				const classNames = `cih-report-block cih-avoid-pg-break cih-${tt.taxonomy.toLowerCase()}`;
				return (
					<div key={tt.taxonomyId} className={classNames}>
						<h4 className="cih-h4 cih-report-heading cih-cnd">{tt.taxonomy}</h4>
						<div className="cih-report-result">
							{separatedText.map((st, i) => (
								<p key={i}>{<SanitizeHTML html={st} />}</p>
							))}
							{tt.taxonomy && tt.scoreBand && (
								<div className="cih-qdbg">
									({tt.taxonomy} - {tt.scoreBand})
								</div>
							)}
						</div>
					</div>
				);
			})}
		</>
	);
});

export default ReportDetails;
